import { NavLink } from 'react-router-dom'
import { FileText, LogOut, FolderKanban, Users } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { isAdminLike } from '../utils/roles'

const Sidebar = ({ isCollapsed }) => {
  const { logout, user } = useAuth()

  const navItems = [
    { path: '/campaigns', label: 'Chiến dịch', icon: FolderKanban },
    { path: '/templates', label: 'Template', icon: FileText },
    ...(isAdminLike(user?.role) ? [{ path: '/users', label: 'Người dùng', icon: Users }] : [])
  ]

  const handleLogout = () => {
    logout()
  }

  return (
    <aside className={`${isCollapsed ? 'w-[94px]' : 'w-[286px]'} flex-shrink-0 hidden border-r border-slate-200/80 bg-[linear-gradient(180deg,#0f172a_0%,#14213d_58%,#16304a_100%)] text-white transition-all duration-300 lg:flex lg:flex-col`}>
      <div className="flex h-full flex-col">
        <div className="px-5 pb-6 pt-7">
          <div className={`flex ${isCollapsed ? 'justify-center' : 'justify-start'} transition-all duration-300`}>
            <img
              src={isCollapsed ? '/OVCMAILER_short_white.png' : '/OVCMAILER_full_white.png'}
              alt="OVC Mailer"
              className={isCollapsed ? 'h-10 w-10 object-contain' : 'h-15 w-auto object-cover object-center'}
            />
          </div>
        </div>

        <nav className={`flex-1 space-y-2 ${isCollapsed ? 'px-3' : 'px-5'}`}>
          {!isCollapsed && (
            <div className="px-2 pb-2 text-[11px] font-bold uppercase tracking-[0.2em] text-white/38">
              Navigation
            </div>
          )}
          {navItems.map((item) => {
            const Icon = item.icon
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `group relative flex items-center rounded-2xl px-4 py-3 text-sm font-semibold transition-all ${
                    isActive
                      ? 'bg-white text-ink shadow-lg shadow-black/10'
                      : 'text-white/78 hover:bg-white/10 hover:text-white'
                  } ${isCollapsed ? 'justify-center' : ''}`
                }
                title={isCollapsed ? item.label : ''}
              >
                <Icon className={`h-5 w-5 flex-shrink-0 ${isCollapsed ? '' : 'mr-3'}`} />
                <span className={`transition-all duration-300 ${isCollapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100'}`}>
                  {item.label}
                </span>

                {isCollapsed && (
                  <div className="absolute left-full ml-3 z-50 rounded-xl bg-slate-900 px-2 py-1 text-xs text-white opacity-0 shadow-lg transition-opacity pointer-events-none whitespace-nowrap group-hover:opacity-100">
                    {item.label}
                  </div>
                )}
              </NavLink>
            )
          })}
        </nav>

        <div className={`${isCollapsed ? 'px-3 pb-4' : 'px-5 pb-5'}`}>
          <button
            onClick={handleLogout}
            className={`group flex w-full items-center rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-semibold text-white/82 transition hover:bg-white/12 hover:text-white ${isCollapsed ? 'justify-center' : ''}`}
            title={isCollapsed ? 'Logout' : ''}
          >
            <LogOut className={`h-5 w-5 flex-shrink-0 ${isCollapsed ? '' : 'mr-3'}`} />
            <span className={`transition-all duration-300 ${isCollapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100'}`}>
              Logout
            </span>

            {isCollapsed && (
              <div className="absolute left-full ml-3 z-50 rounded-xl bg-slate-900 px-2 py-1 text-xs text-white opacity-0 shadow-lg transition-opacity pointer-events-none whitespace-nowrap group-hover:opacity-100">
                Logout
              </div>
            )}
          </button>
        </div>
      </div>
    </aside>
  )
}

export default Sidebar
